export default [
	{ label: 'Recebe QC', value: 1 },
	{ label: 'Pagamento', value: 3 },
	{ label: 'Recebe Ordem de Compra', value: 6 },
	{ label: 'Envia Pedido', value: 7 },
	{ label: 'Administrador de Conta', value: 10 },
	{ label: 'Responsável pela Entrega', value: 11 },
	{ label: 'Visualiza QC', value: 12 },
];
